<template>
    <div>
        <h3 v-show="this.attemptNum > 0" style="margin-top: 25px;">
            <span v-if="reviewMode">Now reviewing: </span>
            <span v-else>This is </span>
            attempt #{{this.attemptNum}}
            <br>
        </h3>
        <i v-if="!reviewMode">Good luck on solving the case!<br>It's OK to make mistakes as long as you learn from them.</i>
        <br><br>
        <md-button class="md-raised md-primary" @click="startCase()">
            Let's Get Started
        </md-button>
        <div v-if="attemptNum > 1 && myReviews[attemptNum-1] == undefined">
            <br>
            <i>It looks like you didn't finish your last case attempt:</i>
            <br>
            <md-button class="md-raised md-primary" @click="resumeCase()" style="background-color: #6886b7;">
                Resume Last Attempt
            </md-button>
        </div>
        <div v-if="responseData && responseData.length > 0 && !this.reviewMode">
            <br>
            <hr>
            <br>
            <h2>
                Past Attempts:
            </h2>
            <br>
            <md-table v-model="summarizeAttempts" md-fixed-header v-if="Object.keys(summarizeAttempts).length != 0" style="border: 2px solid #bbb; border-radius: 4px;">
                <md-table-row slot="md-table-row" v-for="(attemptSummary, attemptIndex) in summarizeAttempts" :key="attemptIndex">
                    <md-table-cell md-label="">
                        {{attemptSummary.Timestamp.toLocaleDateString()}}
                        <br>
                        {{attemptSummary.Timestamp.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}
                    </md-table-cell>
                    <md-table-cell md-label="Attempt">
                        <md-button target="_blank" :href="'/cases/' + caseID + '/attempt/' + attemptSummary.attemptNum" class="md-raised md-primary">
                            Review<br>#{{attemptSummary.attemptNum}}
                        </md-button>
                    </md-table-cell>
                    <md-table-cell md-label="Labs Costs">
                        <span v-if="attemptSummary.Labs['scoreSum'] != undefined && attemptSummary.Labs['nSlides']">
                            Score: {{(attemptSummary.Labs["scoreSum"] / attemptSummary.Labs["nSlides"]).toFixed(0)}}%
                        </span>
                        <span v-if="attemptSummary.Labs['totalCost'] != undefined && attemptSummary.Labs['maxCost']">
                            <br>
                            Spent ${{attemptSummary.Labs["totalCost"]}} of ${{attemptSummary.Labs["maxCost"]}}
                        </span>
                    </md-table-cell>
                    <md-table-cell md-label="Diagnosis" v-if="Object.values(calcQuestionAvgPct('Diagnosis')).some((x) => x != undefined)">
                        {{(attemptSummary.Diagnosis != undefined) ? `${attemptSummary.Diagnosis.toFixed(0)}%` : "Not Assessed"}}
                    </md-table-cell>
                    <md-table-cell md-label="Checklist" v-if="Object.values(calcQuestionAvgPct('Checklist')).some((x) => x != undefined)">
                        {{(attemptSummary.Checklist != undefined) ? `${attemptSummary.Checklist.toFixed(0)}%` : "Not Assessed"}}
                    </md-table-cell>
                    <md-table-cell md-label="Multiple Choice" v-if="Object.values(calcQuestionAvgPct('Multiple Choice')).some((x) => x != undefined)">
                        {{(attemptSummary["Multiple Choice"] != undefined) ? `${attemptSummary["Multiple Choice"].toFixed(0)}%` : "Not Assessed"}}
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <br>
            <hr>
        </div>
    </div>
</template>

<script>

const ObjectID = require("bson-objectid");

export default {
    props: {
        caseID: {
            type: String
        },
        attemptNum: {
            type: Number
        },
        slide: {
            type: Object
        },
        responseData: {
            type: Array
        },
        myReviews: {
            type: Object
        },
        sanitize: {
            type: Function
        },
        reviewMode: {
            type: Boolean
        }
    },
    methods: {
        startCase: function(){
            if(!this.reviewMode){
                if(!confirm("Ready to start? You will lose your progress if you do not finish.")){
                    return
                } 
            }
            this.$emit('setDone', [this.slide.slide.order, true, undefined])
        },
        resumeCase: function(){
            this.$emit('resumeCase', this.attemptNum-1)
        },
        calcQuestionAvgPct: function(slideType){
            var totalScore = {};
            var totalPct = {};
            this.responseData.forEach((responseElem) => {
                var elemAttempt = responseElem.attempt
                if(responseElem.performance && Object.keys(responseElem.performance).includes(slideType)){
                    if(!totalScore[elemAttempt]) totalScore[elemAttempt] = 0
                    if(!totalScore[elemAttempt]) totalPct[elemAttempt] = 0
                    totalScore[elemAttempt] += responseElem.score
                    totalPct[elemAttempt] += 100
                }
            })
            var scores = {}
            Object.keys(totalScore).forEach((attempt) => {
                scores[attempt] = 100*totalScore[attempt] / totalPct[attempt]
            })
            return scores
        },
        calcCosts: function(slideType){
            var labPerformance = {};
            this.responseData.forEach((responseElem) => {
                var elemAttempt = responseElem.attempt
                if(!labPerformance[elemAttempt]) labPerformance[elemAttempt] = {
                    nSlides: 0,
                    scoreSum: 0,
                    totalCost: 0,
                    maxCost: 0,
                }
                if(responseElem.performance && Object.keys(responseElem.performance).includes(slideType)){
                    labPerformance[elemAttempt]["nSlides"]++
                    labPerformance[elemAttempt]["scoreSum"] += responseElem.score
                    labPerformance[elemAttempt]["totalCost"] += responseElem.performance[slideType]["totalCost"]
                    labPerformance[elemAttempt]["maxCost"] += responseElem.performance[slideType]["maxCost"]
                }
            })
            return labPerformance
        },
    },
    computed: {
        summarizeAttempts: function(){
            let attempts = this.attemptNum-1
            let labCosts = this.calcCosts("Labs")
            let diagnosisAvgs = this.calcQuestionAvgPct("Diagnosis")
            let checklistAvgs = this.calcQuestionAvgPct("Checklist")
            let mcAvgs = this.calcQuestionAvgPct("Multiple Choice")
            let summary = []
            Array(attempts).fill().map((_, i) => i+1).forEach((i) => {
                if(!summary[i-1]) summary[i-1] = {}
                summary[i-1].Timestamp = ObjectID(this.responseData.filter((responseElem) => {
                    return responseElem.attempt == i
                })[0].id).getTimestamp()
                summary[i-1].attemptNum = i
                summary[i-1].Labs = labCosts[i]
                summary[i-1].Diagnosis = diagnosisAvgs[i]
                summary[i-1].Checklist = checklistAvgs[i]
                summary[i-1]["Multiple Choice"] = mcAvgs[i]
            })
            return summary.reverse()
        },
    }
}
</script>

<style scoped>
    .md-table >>> .md-table-head-label{
        margin: auto;
        padding: 0px;
    }
    .md-table >>> .md-table-head-container{
        display: flex
    }
    .md-table >>> .md-table-content{
        height: inherit !important;
    }
    .md-table >>> .md-table-cell-container{
        text-align: center;
    }
</style>